export const sizeTinyHeader = "ijQHOe";
export const sizeSmallHeader = "NIDBhd";
export const sizeMediumHeader = "BSJWie";
export const sizeLargeHeader = "DFNSCc";
export const sizeVeryLargeHeader = "jmXtme";
export const sizeHugeHeader = "ppR$Vb";
export const sizeEnormousHeader = "mvTQab";
export default {sizeTinyHeader,sizeSmallHeader,sizeMediumHeader,sizeLargeHeader,sizeVeryLargeHeader,sizeHugeHeader,sizeEnormousHeader};